import { render, staticRenderFns } from "./autoMethod.vue?vue&type=template&id=db53c288&scoped=true&"
import script from "./autoMethod.vue?vue&type=script&lang=js&"
export * from "./autoMethod.vue?vue&type=script&lang=js&"
import style0 from "./autoMethod.vue?vue&type=style&index=0&id=db53c288&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db53c288",
  null
  
)

export default component.exports